export const RENDER_MODAL = 'RENDER_MODAL'
export const REMOVE_MODAL = 'REMOVE_MODAL'
export const DISMISS_MODAL = 'DISMISS_MODAL'

export function renderModal (name, props = {}) {
  return {
    type: RENDER_MODAL,
    payload: { name, props },
  }
}

export function removeModal (name) {
  return {
    type: REMOVE_MODAL,
    payload: { name },
  }
}

export function dismissModal (clickedOverlay) {
  return {
    type: DISMISS_MODAL,
    payload: { clickedOverlay },
  }
}
